"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authenticate = authenticate;
var _events = require("../../types/events");
var _social = require("../../types/social");
var _mrOAuth = require("../../types/mrOAuth");
var _action_types = require("../../constants/action_types");
var _social2 = require("../social");
var _mrOAuthAuthenticate = require("../../api/mrOAuthAuthenticate");
function authenticate(parameters) {
  const {
    email,
    accessToken
  } = parameters;
  return async (dispatch, getState, context) => {
    dispatch({
      type: _action_types.MR_OAUTH_AUTHENTICATE_TYPE,
      status: _mrOAuth.EAuthenticateStatus.Loading
    });
    const source = getState().source;
    await (0, _mrOAuthAuthenticate.mrOAuthAuthenticate)(context.httpApi, {
      email,
      accessToken,
      subdomain: context.subdomain
    }).then(response => {
      if (response.statusCode === 200) {
        switch (response.response.data.status) {
          case _mrOAuthAuthenticate.EMROAuthAuthenticateStatus.Success:
            {
              dispatch({
                type: _action_types.MR_OAUTH_AUTHENTICATE_TYPE,
                status: _mrOAuth.EAuthenticateStatus.Succeed
              });
              const {
                socialLoginId,
                email,
                token
              } = response.response.data;
              dispatch((0, _social2.authenticate)({
                socialType: _social.ESocialType.MailRu,
                socialLoginId,
                email,
                token,
                source
              }));
              break;
            }
          case _mrOAuthAuthenticate.EMROAuthAuthenticateStatus.UserNotFound:
            {
              dispatch({
                type: _action_types.MR_OAUTH_AUTHENTICATE_TYPE,
                status: _mrOAuth.EAuthenticateStatus.Succeed
              });
              const {
                socialLoginId,
                email,
                phone
              } = response.response.data;
              dispatch((0, _social2.authenticateEmailRequired)({
                socialType: _social.ESocialType.MailRu,
                socialLoginId,
                email,
                phone
              }));
              context.emitter.emit(_events.EEventType.MROAuthActionRequired);
              break;
            }
          default:
            throw new Error('Unexpected Mail.Ru OAuth Status');
        }
        return;
      }
      const {
        error
      } = response.response.data;
      dispatch({
        type: _action_types.MR_OAUTH_AUTHENTICATE_TYPE,
        status: _mrOAuth.EAuthenticateStatus.Failed,
        error
      });
    }).catch(error => {
      context.logger.error(error, {
        domain: 'auth-widget.api.mrOAuth'
      });
      dispatch({
        type: _action_types.MR_OAUTH_AUTHENTICATE_TYPE,
        status: _mrOAuth.EAuthenticateStatus.Failed,
        error: 'Произошла непредвиденная ошибка'
      });
    });
  };
}